<script setup lang="ts">
import { B2BTrackingEvents } from '~/enums/tracking/b2b.enums';

const visible = defineModel<boolean>('visible');

defineProps<{
  groupName: string;
}>();

const { t } = useI18n();
const { between } = useScreen();
const { dispatchTrackingEvent } = useTracking();

const showAppPromo = computed<boolean>(() => between(992));

const handleShow = () => {
  if (showAppPromo.value) {
    dispatchTrackingEvent(B2BTrackingEvents.MobileAppPromoShown);
  }
};

const handleStartLearning = () => {
  visible.value = false;

  if (showAppPromo.value) {
    dispatchTrackingEvent(B2BTrackingEvents.MobileAppPromoStartLearningClicked);
  }
};
</script>

<template>
  <Dialog
    v-model:visible="visible"
    :close-on-escape="false"
    :modal="true"
    :show-header="false"
    :pt="{
      root: {
        class: 'relative flex items-center justify-center w-auto mx-auto h-auto'
      },
      content: {
        class: 'rounded-xl'
      }
    }
    "
    @show="handleShow"
  >
    <div class="flex flex-col p-4 gap-2 sm:w-[340px]">
      <div class="mb-3 flex justify-center">
        <img
          src="@images/gifs/confetti.gif"
          :alt="t('dashboard.b2b.welcome.successAlt')"
          class="w-[120px] h-[120px]"
        >
      </div>
      <div class="text-22 font-bold text-center mb-2">
        {{t('dashboard.b2b.welcome.title')}}
      </div>
      <div
        v-if="groupName"
        class="text-16 text-neutral-70 text-center"
      >
        {{t('dashboard.b2b.welcome.memberOf', {groupName})}}
      </div>
      <Button
        rounded
        severity="primary"
        :label="t('dashboard.b2b.welcome.startLearning')"
        class="mx-auto !mt-4"
        @click="handleStartLearning"
      />
    </div>
    <div
      v-if="showAppPromo"
      class="flex flex-col items-center gap-1 p-4 mt-2 border-t border-neutral-30"
    >
      <MobileAppPromoQr
        :alt="t('dashboard.b2b.welcome.appPromo.qrAlt')"
        utm-source="b2b_welcome_dialog"
        class="mb-3"
      />
      <div class="text-16 font-bold text-center">
        {{t('dashboard.b2b.welcome.appPromo.title')}}
      </div>
      <div class="text-14 text-neutral-70 text-center">
        {{t('dashboard.b2b.welcome.appPromo.subtitle')}}
      </div>
    </div>
  </Dialog>
</template>
